import * as react from "react"
import { Navigate } from "react-router-dom"
import PlanesCotizacion from "../../../components/PlanesCotizacion/PlanesCotizacion"

const CotizacionPlanes = (props) => {
    const existDataSession =  sessionStorage.getItem("interContratante")? true : false
    return (
        existDataSession? <PlanesCotizacion isMobile={props.isMobile} /> : <Navigate to="/inicio?view=haveCotizacion" />
    )
}

export default CotizacionPlanes